<div class="container-fluid py-4" *ngIf="community">
  <div class="py-4">
    <app-breadcrumb-navigation
      [showPreviousPage]="isAuthenticated && !isAdminSession"
      [link]="LINK_COMMUNITIES"
      [dataTestId]="'communities-link'"
      [pageToNavigateTitle]="'PROFILE_NAVIGATION_COMMUNITIES'"
      [pageTitle]="community.title"
      [status]="isPrivate ? PRIVATE : EMPTY"
    ></app-breadcrumb-navigation>
  </div>
  <div class="mb-4">
    <button
      *ngIf="community.permissions.invite_users"
      data-test-id="btn-community-invite"
      type="button"
      class="btn btn-primary me-3"
      (click)="inviteToCommunity()"
    >
      {{ 'BTN_INVITE_TO_COMMUNITY' | translate }}
    </button>
    <button
      *ngIf="community.permissions.update"
      data-test-id="btn-manage"
      [routerLink]="[LINK_COMMUNITY_MANAGE, community.entity_id]"
      type="button"
      class="btn btn-outline-primary me-3"
    >
      {{ 'BTN_EDIT' | translate }}
    </button>
    <button
      *ngIf="community.permissions.leave"
      (click)="leaveCommunity()"
      data-test-id="btn-leave"
      type="button"
      class="btn btn-outline-primary me-3"
    >
      {{ 'BTN_LEAVE_COMMUNITY' | translate }}
    </button>
    <button
      appLongOperation
      *ngIf="community.permissions.request_to_join"
      (click)="joinCommunity()"
      data-test-id="btn-join"
      type="button"
      class="btn btn-primary me-3"
    >
      {{ (community.status === 'open' ? 'BTN_JOIN_COMMUNITY' : 'BTN_REQUEST_TO_JOIN_COMMUNITY') | translate }}
    </button>
  </div>
  <div class="tab-holder">
    <ul ngbNav #nav="ngbNav" (navChange)="onTabClick($event)" class="nav-tabs">
      <li ngbNavItem="community_info">
        <a ngbNavLink [attr.data-test-id]="'community_info'">
          {{ 'COMMUNITY_TAB_INFO' | translate }}
        </a>

        <ng-template ngbNavContent>
          <div class="info-community-holder">
            <app-info-community [entity]="community"></app-info-community>
          </div>
          <app-carousel
            *ngIf="community?.linked_communities.length"
            [data]="community.linked_communities"
            [type]="CardType.COMMUNITY"
            [title]="'LINKED_COMMUNITIES_TITLE'"
          >
          </app-carousel>

          <ng-container *ngIf="isSuggestedCommunitiesLoading">
            <div
              class="spinner-grow text-primary m-5"
              role="status"
              data-test-id="suggested-communities-loading-spinner"
            >
              <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
            </div>
          </ng-container>
          <app-carousel
            *ngIf="suggestedCommunities?.length"
            [data]="suggestedCommunities"
            [type]="CardType.COMMUNITY"
            [title]="'SUGGESTED_COMMUNITIES_TITLE'"
          >
          </app-carousel>
        </ng-template>
      </li>

      <ng-container *ngIf="community.permissions.view_members">
        <li ngbNavItem="community_members">
          <a ngbNavLink [attr.data-test-id]="'community_members'">
            {{ 'COMMUNITY_TAB_MEMBERS' | translate }} ({{ counters?.members_count }})
          </a>

          <ng-template ngbNavContent>
            <app-spinner>
              <app-table-users-list
                [tableConstructorData]="membersTableConstructorData"
                [noUsersHint]="'NO_COMMUNITY_MEMBERS_TEXT'"
                [redirectToLoginIfNoSession]="true"
                (action)="deleteMember($event)"
              ></app-table-users-list>
              <div class="mt-1" *ngIf="membersTotalCount > pageSize">
                <ngb-pagination
                  class="w-100 d-flex justify-content-center pagination custom-pagination"
                  data-test-id="sent-requests-pagination-box"
                  [collectionSize]="membersTotalCount"
                  [(page)]="membersPageNumber"
                  [maxSize]="3"
                  [pageSize]="pageSize"
                  [rotate]="true"
                  (pageChange)="onMembersPageChanged($event)"
                ></ngb-pagination>
              </div>
            </app-spinner>
          </ng-template>
        </li>
      </ng-container>

      <ng-container *ngIf="community.permissions.view_posts">
        <li ngbNavItem="community_posts">
          <a ngbNavLink [attr.data-test-id]="'community_posts'">
            {{ 'COMMUNITY_TAB_POSTS' | translate }} ({{ counters?.posts_count }})
          </a>

          <ng-template ngbNavContent>
            <app-spinner>
              <app-items-list
                [items]="posts"
                [searchState]="resolver.state"
                [itemsListContent]="postsHelperContent"
                [type]="CardType.POST"
                [noItemsTitle]="'COMMUNITY_NO_POSTS'"
                (pageChanged)="resolver.onPageChanged($event)"
              ></app-items-list>
            </app-spinner>
          </ng-template>
        </li>
      </ng-container>

      <ng-container *ngIf="community.permissions.view_projects">
        <li ngbNavItem="community_projects">
          <a ngbNavLink [attr.data-test-id]="'community_projects'">
            {{ 'COMMUNITY_TAB_PROJECTS' | translate }} ({{ counters?.projects_count }})
          </a>

          <ng-template ngbTabTitle>
            {{ 'COMMUNITY_TAB_PROJECTS' | translate }} ({{ counters?.projects_count }})
          </ng-template>
          <ng-template ngbNavContent>
            <app-spinner>
              <app-items-list
                [items]="projects"
                [searchState]="resolver.state"
                [itemsListContent]="projectsHelperContent"
                [type]="CardType.PROJECT"
                [noItemsTitle]="'COMMUNITY_NO_PROJECTS'"
                (pageChanged)="resolver.onPageChanged($event)"
              ></app-items-list>
            </app-spinner>
          </ng-template>
        </li>
      </ng-container>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>
